;(function () {
  function initBreadcrumbCollectionContext() {
    try {
      var STORAGE_KEY = 'last_collection_context';

      // 1. Capture collection handle + title when clicking a product card
      var productCardWrappers = document.querySelectorAll(
        '.card-wrapper.product-card-wrapper[data-rendered-collection]'
      );

      productCardWrappers.forEach(function (wrapper) {
        var collectionHandle = wrapper.getAttribute('data-rendered-collection');
        if (!collectionHandle) return;

        var collectionTitle =
          wrapper.getAttribute('data-rendered-collection-title') || '';

        wrapper.addEventListener('click', function (event) {
          var link = event.target.closest('a[href*="/products/"]');
          if (!link) return;

          // Derive the product path from the clicked link
          var productPath = '';
          try {
            var url = new URL(link.href, window.location.origin);
            productPath = url.pathname;
          } catch (e) {
            productPath = link.getAttribute('href') || '';
          }

          var payload = {
            handle: collectionHandle,
            title: collectionTitle,
            productPath: productPath,
          };

          try {
            window.sessionStorage.setItem(
              STORAGE_KEY,
              JSON.stringify(payload)
            );
          } catch (e) {
            // Ignore storage errors
          }
        });
      });

      // 2. On product page (URL-based), enhance breadcrumbs if we have stored context
      var path = window.location.pathname || '';
      var isProductUrl = path.indexOf('/products/') !== -1;
      if (!isProductUrl) return;

      var stored = null;
      try {
        stored = window.sessionStorage.getItem(STORAGE_KEY);
      } catch (e) {
        stored = null;
      }

      if (!stored) return;

      var context;
      try {
        context = JSON.parse(stored);
      } catch (e) {
        // Backwards compatibility: if old string value was stored
        context = { handle: stored, title: '', productPath: '' };
      }

      if (!context || !context.handle) return;

      var currentPath = window.location.pathname || '';

      // Only show the collection if this stored context was created
      // specifically for this product URL. This prevents showing an
      // unrelated collection when navigating from places like the cart.
      if (context.productPath && context.productPath !== currentPath) {
        return;
      }

      var handle = context.handle;
      var title =
        context.title && context.title.trim().length
          ? context.title
          : handle.replace(/-/g, ' ');

      var breadcrumbsRoot = document.querySelector('.custom-breadcrumbs ul');
      if (!breadcrumbsRoot) return;

      // Avoid duplicates if a collection crumb for this handle already exists
      if (
        breadcrumbsRoot.querySelector(
          'a[href$="/collections/' + handle.replace(/"/g, '\\"') + '"]'
        )
      ) {
        return;
      }

      var productItem = breadcrumbsRoot.querySelector('li:last-child span');
      if (!productItem) return;

      // Build new list item for collection
      var collectionLi = document.createElement('li');
      var collectionLink = document.createElement('a');
      collectionLink.href = '/collections/' + handle;
      collectionLink.textContent = title;
      collectionLi.appendChild(collectionLink);

      breadcrumbsRoot.insertBefore(collectionLi, productItem.parentElement);

      // Insert icon between collection and product
      var iconTemplate = document.querySelector(
        '.custom-breadcrumbs .breadcrumbs-icon'
      );
      if (iconTemplate && iconTemplate.outerHTML) {
        var iconLi = document.createElement('li');
        iconLi.innerHTML = iconTemplate.outerHTML;
        breadcrumbsRoot.insertBefore(iconLi, productItem.parentElement);
      }
    } catch (e) {
      // Fail silently; breadcrumbs fallback will still show product only
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBreadcrumbCollectionContext);
  } else {
    initBreadcrumbCollectionContext();
  }
})();

